<template>
  <div class="has-background-light p-6" style="height: 100%; overflow-y: auto">
    <div class="container px-6">
      <div class="block mb-4">
        <h1 class="title has-text-centered">SUCHERGEBNISSE</h1>
      </div>
      <div class="block">
        <SearchBar
          ref="searchBar"
          :productName="productName"
          :tag="tag"
          hideCloseBtn
          lazy
        >
          <template #info="{ search }">
            <div
              v-html="searchInfo(search)"
              class="mt-3 mb-2"
              style="font-size: 14px"
            />
          </template>

          <template #result="{ search, methods }">
            <div class="py-4">
              <div
                v-for="(route, index) in search.found"
                :key="route.id"
                class="section pt-3 pb-2 mb-4 result-item-wrapper"
                style="border: 1px solid #ac8856"
                :class="{ active: index === search.selectedItemIndex }"
                @mouseover="methods.selectResult(index)"
              >
                <!--
                The actual redirection is handled by viewDashboard.
                The searchResultItemLink is only for presentational purpose:
                displaying the target link at the bottom-left of the screen on hover
                -->
                <router-link
                  :to="methods.searchResultItemLink(route)"
                  @click.prevent="methods.viewDashboard(route)"
                  class="
                    has-text-dark
                    is-flex
                    is-justify-content-space-between
                    is-align-items-center
                    search-result-item
                  "
                >
                  <div>
                    <span
                      class="search-result-item-heading has-text-weight-bold"
                    >
                      {{ route.search_title }}
                    </span>
                    <breadcrump :item="route" :routes="search.routes" />
                  </div>
                  <b-button
                    @click.prevent="methods.viewDashboard(route)"
                    type="is-gold"
                    size="is-small"
                    icon-right="angle-right"
                    class="view-dashboard-btn"
                    outlined
                  />
                </router-link>
              </div>
            </div>
            <p v-if="search.keyword" class="pt-3">
              Nicht gefunden, wonach Sie suchen? Wir helfen Ihnen gerne weiter!
              <a href="mailto:support@standortmonitor.net">
                Kontaktieren Sie uns.</a
              >
            </p>
          </template>
        </SearchBar>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar.vue';
import Breadcrump from '@/components/helper/Breadcrump.vue';

export default {
  name: 'SearchResult',

  components: {
    SearchBar,
    Breadcrump,
  },

  props: {
    productName: {
      type: String,
      default: 'all',
    },
    tag: {
      type: String,
      default: '',
    },
  },

  methods: {
    searchInfo({ found, keyword, product }) {
      return `${found.length} Ergebnisse für
              <strong>„${keyword}“</strong> in
              <u>${product.name ? product.name : 'all products.'}</u>`;
    },
  },

  mounted() {
    this.$refs.searchBar.highlight(this.tag);
  },

  updated() {
    this.$refs.searchBar.highlight(this.tag);
  },
};
</script>

<style>
.result-item-wrapper {
  background-color: white;
}

.result-item-wrapper.active {
  background-color: #f1ebe4;
}

.result-item-wrapper.active .button.view-dashboard-btn {
  background-color: white;
}

.result-item-wrapper.active .button.view-dashboard-btn:hover {
  background-color: #ac8856;
}
</style>
